import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { appConstants } from '../constants';
import { GlobalService } from '../Servicios/global.service';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
@Component({
  selector: 'app-search-section',
  templateUrl: './search-section.component.html',
  styleUrls: ['./search-section.component.scss']
})
export class SearchSectionComponent implements OnInit {
  public showFilters = false;
  public showSortModal = false;
  public SORT_NAMES = appConstants.sortNames;
  public SORT_CATEGORIES = appConstants.sortingCategories; 
  public sorting = this.SORT_CATEGORIES.description;
  public filters = {};

  constructor(
    private global: GlobalService,
    private fb : FormBuilder,
    public Utilidades: UtilidadesService,
    private _router: Router
  ) { }

  ngOnInit(): void {
  }

  clickFilter() : void {
    this.showFilters = !this.showFilters;
  }

  clickSort() : void {
    this.showSortModal = !this.showSortModal;
  }

  sortApply(): void {
    this.global.SortProducts.Sorting = this.sorting;
    this.showSortModal = !this.showSortModal;
  }

  isMobile(): boolean {
    return window.innerWidth < 991 ;
  }
}
